/* eslint-disable import/prefer-default-export */
export const findByKey = (needle, haystack = []) => haystack.find(x =>
    x.key && x.key.toString() === needle && needle.toString());



// WEBPACK FOOTER //
// ./app/components/change-course/helpers.js